@if (form$ | async; as form) {
  <igo-form
    [form]="form"
    [formData]="data$ | async"
    (submitForm)="onSubmit($event)"
  >
    @if (form.fields.length) {
      <div class="form-container">
        @for (field of form.fields; track field) {
          <igo-form-field [field]="field" />
        }
      </div>
    }
    <div formButtons class="actions-container">
      <button
        mat-stroked-button
        type="button"
        color="primary"
        (click)="clear()"
      >
        {{
          'igo.geo.workspace.widget.interactiveSelection.reset.button'
            | translate
        }}
      </button>
      <button
        matButton="filled"
        type="submit"
        color="primary"
        [disabled]="submitDisabled"
      >
        {{ submitButtonText$ | async | translate }}
      </button>
    </div>
  </igo-form>
}
